<template>
  <div class="login-view">
    <div class="login-content">
      <!-- Placeholder Logo -->
      <div class="logo-placeholder"></div>
  <h2>Welcome!</h2>
      <p>Please sign in to continue.</p>
      <button @click="handleLogin" :disabled="isLoggingIn">
        {{ isLoggingIn ? 'Signing in...' : 'Sign In' }}
      </button>
      <div v-if="loginError" class="login-error">
        {{ loginError }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useAuth } from "@/composables/useAuth";

const { login } = useAuth();
const isLoggingIn = ref(false);
const loginError = ref<string | null>(null);

const handleLogin = async () => {
  isLoggingIn.value = true;
  loginError.value = null;
  
  try {
    await login();
  } catch (error) {
    loginError.value = error instanceof Error ? error.message : "Login failed";
  } finally {
    isLoggingIn.value = false;
  }
};
</script>

<style scoped>
.login-view {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  padding: 2rem;
  min-height: 60vh;
}

.login-content {
  text-align: center;
  padding: 2rem;
  border: 1px solid #eee;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.logo-placeholder {
  width: 60px;
  height: 60px;
  background-color: #bbb;
  border-radius: 50%;
  margin: 0 auto 1rem auto;
}

h2 {
  margin-bottom: 0.5rem;
  color: #333;
}

p {
  margin-bottom: 1.5rem;
  color: #555;
}


button {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 400; /* non-bold */
  border: none;
  border-radius: 8px;
  color: #fff;
  background: linear-gradient(180deg, #2563EB 0%, #1E40AF 100%);
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.12);
  transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease;
}

button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(37, 99, 235, 0.14);
}

button:focus {
  outline: none;
  box-shadow: 0 0 0 6px rgba(37, 99, 235, 0.10);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.login-error {
  color: #c00;
  margin-top: 1rem;
  font-size: 0.9rem;
}
</style>